var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-page-wrapper"},[_c('div',{staticClass:"pdf-page"},[_c('img',{staticClass:"coverImage",attrs:{"src":_vm.data.backCoverImage,"crossorigin":"anonymous"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }